/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FluentLogLine
 */
export interface FluentLogLine {
    /**
     * 
     * @type {number}
     * @memberof FluentLogLine
     */
    timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof FluentLogLine
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof FluentLogLine
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof FluentLogLine
     */
    instance: string;
    /**
     * 
     * @type {number}
     * @memberof FluentLogLine
     */
    instanceId?: number;
    /**
     * 
     * @type {string}
     * @memberof FluentLogLine
     */
    logType: string;
}

/**
 * Check if a given object implements the FluentLogLine interface.
 */
export function instanceOfFluentLogLine(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "timestamp" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "instance" in value;
    isInstance = isInstance && "logType" in value;

    return isInstance;
}

export function FluentLogLineFromJSON(json: any): FluentLogLine {
    return FluentLogLineFromJSONTyped(json, false);
}

export function FluentLogLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): FluentLogLine {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timestamp': json['timestamp'],
        'message': json['message'],
        'source': json['source'],
        'instance': json['instance'],
        'instanceId': !exists(json, 'instance_id') ? undefined : json['instance_id'],
        'logType': json['log_type'],
    };
}

export function FluentLogLineToJSON(value?: FluentLogLine | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'timestamp': value.timestamp,
        'message': value.message,
        'source': value.source,
        'instance': value.instance,
        'instance_id': value.instanceId,
        'log_type': value.logType,
    };
}

